export default function generateIconUrl(iconName, folder){
    if(!iconName || !folder){
        return null;
    }

    return `${process.env.REACT_APP_API_BASE_URL}/blob?path=${folder}/${iconName}.svg`
}

